<ng-container *ngIf="data">
  <app-search [itemsPerPage]='data.defaultResultsCount'></app-search>

  <app-panels *ngIf="data.panels && data.panels.value" [items]="data.panels.value"></app-panels>
</ng-container>
